import { Component, inject, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { GeoJSONDatabaseService } from "../../viewer-components/services/internal-services/geojson-database.service";
import { WmsLayerResultsDialogComponent } from "./wms-layer-results-dialog.component";
import { PhoenixViewerService } from "../../viewer-components/services/internal-services/viewer-services/phoenix-viewer.service";
import { Viewerlayer } from "../../viewer-components/model/viewerlayer";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";
import {
  GoogleAnalyticsConstantsCategory,
  GoogleAnalyticsConstantsEvents,
} from "../../shared/model/google-analytics-constants";
import { GoogleAnalyticsService } from "../../shared/services/google-analytics.service";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  selector: "phoenix-wms-layer-results-dialog-component",
  templateUrl: "./wms-layer-results-dialog.component.html",
  styleUrls: ["./wms-layer-results-dialog.component.scss"],
  providers: [MatDialogConfig],
  standalone: false,
})
export class PhoenixWmsLayerResultsDialogComponent extends WmsLayerResultsDialogComponent {
  constructor(
    http: HttpClient,
    viewerConfigurationService: ViewerConfigurationService,
    geoJSONDatabaseService: GeoJSONDatabaseService,
    googleAnalyticsService: GoogleAnalyticsService,
    matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
    @Inject(VIEWER_SERVICE) public viewerService: BaseViewerService,
  ) {
    super(http, viewerConfigurationService, geoJSONDatabaseService, googleAnalyticsService, matDialog, data);
    this.viewerService = data.viewerService;
  }

  saveLayer(layer: Viewerlayer) {
    this.geoJSONDatabaseService.saveLayer(layer).subscribe(() => {
      this.viewerService.addUserLayer(layer);
      this.viewerService.updateUserOrder(this.viewerService.getUserLayers());
    });
    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.ADD_DATA_WMS,
      GoogleAnalyticsConstantsCategory.LEFT_TOOLBAR,
      true,
    );
  }
}
